import { css } from '@emotion/css';

import { SMALL_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

export const cardDetailsClassName = css({
  paddingBottom: Spacing.XS,
  [SMALL_DEVICE_MQ]: {
    paddingBottom: 0,
  },
});

export const emojiPickerClassName = css({
  bottom: '-64px',
  boxShadow: `0px 2px 4px 0px rgb(63, 63, 63, 0.1), 0px -1px 2px rgb(63, 63, 63, 0.075)`,
  borderRadius: 8,
});
